var $ec41eb3cc4866d2c$exports = {};
$ec41eb3cc4866d2c$exports = {
    "collectionLabel": `Forslag`
};


export {$ec41eb3cc4866d2c$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
